import { makeRequest } from '@/base/MaRequestPooler.js'

/**
 * @param {object} data - The annotation details.
 * @param {number} data.chartId - Unique identifier for the chart.
 * @param {string} data.colorCode - Color code in hexadecimal format.
 * @param {string} data.text - Annotation text.
 * @param {string} data.dateTime - Date and time of the annotation in ISO 8601 format.
 * @param {boolean} data.isPrivate - Indicates if the annotation is private.
 * @param {boolean} data.alwaysOn - Indicates if the annotation should always be displayed.
 * @param {number} data.iconId - Identifier for the icon associated with the annotation.
 * @param {string|number} data.trackId - Identifier for the track associated with the annotation.
 * @returns {Promise<any>} Promise object representing the server response.
 */
export function addChartAnnotation(data) {
  return makeRequest(`/account/chart-annotation`, {
    method: 'POST',
    data,
  })
}

/**
 * @param {number} id - The unique identifier of the annotation to be edited.
 * @param {object} data - The new annotation details.
 * @param {number} data.chartId - Unique identifier for the chart.
 * @param {string} data.colorCode - Color code in hexadecimal format.
 * @param {string} data.text - Updated annotation text.
 * @param {string} data.dateTime - Updated date and time of the annotation in ISO 8601 format.
 * @param {boolean} data.isPrivate - Updated privacy status of the annotation.
 * @param {boolean} data.alwaysOn - Updated display status of the annotation.
 * @param {number} data.iconId - Updated identifier for the icon associated with the annotation.
 * @param {string|number} data.trackId - Updated identifier for the track associated with the annotation.
 * @returns {Promise<any>} Promise object representing the server response.
 */
export function editChartAnnotation(id, data) {
  return makeRequest(`/account/chart-annotation/${id}`, {
    method: 'POST',
    data,
  })
}

/**
 * @param {number} id - The unique identifier of the annotation to be deleted.
 * @returns {Promise<any>} Promise object representing the server response.
 */
export function deleteChartAnnotation(id) {
  return makeRequest(`/account/chart-annotation/${id}`, {
    method: 'DELETE',
  })
}

/**
 * Retrieves all chart annotations.
 * @returns {Promise<any>} Promise object representing the server response with all chart annotations.
 */
export function getChartAnnotations() {
  return makeRequest(`/account/chart-annotation`)
}
